export default __webpack_public_path__ + "static/media/vib_2.99f0b847.png";